export const BASE_URL = 'https://gs-mkt-autos-api-logs-dev-fyy4ranv6a-ue.a.run.app';
export const BASE_IMG_URL = '';
export const LOGGING_API_BASE_URL = 'https://gs-mkt-autos-api-logs-dev-fyy4ranv6a-ue.a.run.app';
export const LOGGING_API_REGISTER_STEP = `${BASE_URL}/api/v1/logs/public/register-step`;

// APP CONFIG
export const CLIENT_ID = '16';
export const CLIENT_SECRET = 'NVgSETohfLVnHTYgf1AP23nGfh9RbprrbVTeuJg6';
export const CLIENT_USERNAME = 'agente@marketplaceGDS.com.mx';
export const CLIENT_PASSWORD = 'MarketplaceGDS123.';
export const APP_TOTAL_STEPS = 8;

// API URLS
export const API_TOKEN_URL = `${BASE_URL}/oauth/token`;
export const POSTAL_CODE_VALIDATE_URL = `${BASE_URL}/api/sepomex/%P_CODE%`;
export const POSTAL_CODE_CATALOG_URL = `${BASE_URL}/api/sepomex/%P_CODE%/settlemets`;
export const GET_BRANDS_URL = `${BASE_URL}/api/vehicle/brands`;
export const GET_SUBBRANDS_URL = `${BASE_URL}/api/vehicle/%BRAND%/subbrands`;
export const GET_MODELS_URL = `${BASE_URL}/api/vehicle/%BRAND%/%SUBBRAND%/models`;
export const GET_VERSIONS_URL = `${BASE_URL}/api/vehicle/%BRAND%/%SUBBRAND%/%MODEL%/versions`;
export const GET_QUOTES_URL = `${BASE_URL}/api/coverage/quotes`;
export const GET_ACTIVITIES_URL = `${BASE_URL}/api/catalog/activities`;
export const GET_NATIONALITIES_URL = `${BASE_URL}/api/catalog/nationalities`;
export const GET_SEPOMEX_URL = `${BASE_URL}/api/sepomex/%POSTALCODE%/settlements`;
export const GET_GENDERS_URL = `${BASE_URL}/api/catalog/genders`;
export const GET_MARITAL_STATUSES_URL = `${BASE_URL}/api/catalog/maritalStatus`;
export const GET_OCCUPATIONS_URL = `${BASE_URL}/api/catalog/ocupations`;
export const GET_TAX_REGIMES_URL = `${BASE_URL}/api/catalog/taxregimes`;
export const GET_PERSON_TYPE_URL = `${BASE_URL}/api/catalog/typePerson`;
export const GET_VEHICLE_SERVICES_URL = `${BASE_URL}/api/catalog/vehicle/service`;
export const GET_VEHICLES_TYPES_URL = `${BASE_URL}/api/catalog/vehicle/type`;
export const GET_USES_OF_THE_VEHICLE_URL = `${BASE_URL}/api/catalog/vehicle/%VEHICLE_TYPE_ID%/use`;
export const POST_PAYMENT_URL = `${BASE_URL}/api/billing/charge`;
export const POST_EMIT_POLICY_URL = `${BASE_URL}/api/emission/save`;
export const POST_EMISSION_DOCUMENTS_URL = `${BASE_URL}/api/emission/documents`;
export const GET_BENEFICIARIES_URL = `${BASE_URL}/api/catalog/preferredBeneficiary`;

// OTHERS
// Map for the url's used in the navigation.
export const NAVIGATION_PATHS = [
  '', // due logistic reasons, the 0 index of this array is not used.
  '/inicio', // Form1 - LandingPage
  '/cotizador/datos-iniciales-vehiculo', // Form2
  '/cotizador/seleccion-plan', // Form3
  '/cotizador/datos-asegurado', // Form4
  '/cotizador/datos-contratante', // Form5
  '/cotizador/datos-adicionales-vehiculo', // Form6
  '/cotizador/pago', // Form7
  '/cotizador/resumen-contratacion', // FormEnding (techmically Form8)
];

// Values for person type
export const PHYSICAL_PERSON_VALUE = '1';
export const MORAL_PERSON_VALUE = '2';

// LINK HREFs
export const LOGO_HREF = '.';

// GOOGLE TAG MANAGE
export const GTM_ID = 'GTM-TZ8T2FL';

// XMAS SALES
export const XMAS_MIN_PURCHASE_AMOUNT = 6000;
